import { Phone, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { cn } from '../lib/utils';
import { useSettingsStore } from '../state/useSettingsStore';
import { formatPhoneNumber } from './formatPhoneNumber';

interface TelmePhonesProps {
  className?: string;
}

const TelmePhones = ({ className }: TelmePhonesProps) => {
  const phoneNumbers = useSettingsStore(s => s.settings.phoneNumbers);
  const whatsappNumber = useSettingsStore(s => s.settings.whatsappNumber);

  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <div className="flex items-center gap-1 flex-wrap">
        <Phone size={16} />
        {phoneNumbers.map((num, index) => (
          <span key={num}>
            <Link to={`tel:${num}`} target="_blank" className="hover:underline">
              {formatPhoneNumber(num, index !== 0)}
            </Link>
            {index !== phoneNumbers.length - 1 && '/'}
          </span>
        ))}
      </div>
      {whatsappNumber && (
        <div className="flex items-center gap-1">
          <MessageCircle size={16} />
          <Link to={`https://wa.me/${whatsappNumber}`} target="_blank" className="hover:underline">
            {formatPhoneNumber(whatsappNumber)}
          </Link>
        </div>
      )}
    </div>
  );
};

export default TelmePhones;
